import createIcon from '../../createIcon';

/**
 * @component @name TextRotateUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxMlYxMy41TDE0IDE4LjI1VjE2LjE1TDExLjggMTUuMjVWMTAuMjVMMTQgOS4zNVY3LjI1TDMgMTJaTTEwIDE0LjYyTDQuOTggMTIuNzVMMTAgMTAuODhWMTQuNjJaTTE4IDQuMjVMMTUgNy4yNUgxN1YxOS43NUgxOVY3LjI1SDIxTDE4IDQuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotateUp = createIcon('TextRotateUp', [
  [
    'path',
    {
      d: 'M3 12V13.5L14 18.25V16.15L11.8 15.25V10.25L14 9.35V7.25L3 12ZM10 14.62L4.98 12.75L10 10.88V14.62ZM18 4.25L15 7.25H17V19.75H19V7.25H21L18 4.25Z',
      key: '1599co',
    },
  ],
]);

export default TextRotateUp;
